import { Paper } from "@mui/material";
import {useOutletContext} from "react-router-dom"
import { DataGrid ,GridToolbarContainer,GridToolbarFilterButton, GridToolbarQuickFilter} from '@mui/x-data-grid';
import { useState } from "react";
import ReAuthDeleteDialog from "../../components/ReAuthDeleteDialog";
import { Weed as Managed } from "../../features/db/weed";
import Dialog from "../../components/NewWeedDialog";

export default function ChemicalPage() {
	const { weedsContainer } = useOutletContext();
	const [rows, setRows] = weedsContainer;

	const [selectionModel, setSelectionModel] = useState([]);

	const columns = [
		{ field: 'name', headerName: 'Weed', flex:1},
	];

	const submitCallback = (p)=>
	{
		setRows([...rows, p]);
	}

	const handleDelete = ()=>
	{
		if(selectionModel.length > 0)
		{
			Managed.deleteAndUpdate(selectionModel,rows,setRows);
		}
	}

	const CustomToolbar = ({ setFilterButtonEl }) => (
		<GridToolbarContainer sx = {{m:1}}>
			<GridToolbarQuickFilter />
			<GridToolbarFilterButton ref={setFilterButtonEl} />
			<Dialog submitCallback={submitCallback}/>
			<ReAuthDeleteDialog handleDelete = {handleDelete} selectionSize = {selectionModel.length}/>
		</GridToolbarContainer>
	);

	return (
		<Paper varient="outlined" sx={{m:2}} elevation={10}>
			<DataGrid
				autoHeight
				rows={rows}
				columns={columns}
				checkboxSelection
				components={{Toolbar: CustomToolbar }}
				disableColumnSelector
				disableDensitySelector
				onSelectionModelChange = {(newSelectionModel) => {
					setSelectionModel(newSelectionModel);
				}}
				selectionModel={selectionModel}
				getRowHeight={() => 'auto'}
			/>
		</Paper>
	);
}